import { Component, OnInit } from "@angular/core";
import { LandingService } from "./landing.service";
import { SessionStorage } from "ngx-webstorage";
import { Router } from "@angular/router";
import { MatDialog, MatSnackBar } from "@angular/material";
import { Landing, UserDetails } from "./landing";
import { ApplicationConfig } from "../../utils/models/config";
import { ConfigService } from "../../utils/services/config.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { BroadcastService, MsalService } from "@azure/msal-angular";
import { HttpClient } from "@angular/common/http";
import { HttpServiceHelper } from "../HttpServiceHelper";
import { Subscription } from "rxjs";
import { VerticalDepartmentPopUpComponent } from "../vertical-department-pop-up/vertical-department-pop-up.component";
import { ProfileService } from "../profile/profile.service";
@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.css"],
})
export class LandingComponent implements OnInit {
  private subscription: Subscription;
  managerData;
  meData;
  managerUrl = "https://graph.microsoft.com/v1.0/me/manager";
  meUrl = "https://graph.microsoft.com/v1.0/me/?$select=displayName,EmployeeID";

  private _initialRoutes = {
    ADMIN: "/admin/dashboard",
    EMP: "/employee/dashboard",
    RM: "/rm/dashboard",
  };
  @SessionStorage("user") public loggedInUser;
  @SessionStorage("userObj") public userObj;
  @SessionStorage("x-access-token") public token;
  @SessionStorage("config") public config;

  public landing = new Landing({});
  public loginConfig = null;
  public currentYear;

  constructor(
    private authService: MsalService,
    private http: HttpClient,
    private httpService: HttpServiceHelper,
    private broadcastService: BroadcastService,
    public landingService: LandingService,
    public configService: ConfigService,
    public router: Router,
    public snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    public vertInfoDialog: MatDialog,
    public profileServ: ProfileService
  ) {}
  private loginApiSubscription: Subscription;
  ngOnInit() {
    const d = new Date();
    this.currentYear = d.getFullYear();
    this.token = null;
    this.userObj = null;
    this.meData = {
      employeeId: "",
      displayName: "",
    };
    this.managerData = null;

    this.spinnerService.show();

    this.broadcastService.subscribe("msal:loginFailure", (payload) => {
      console.log("login failure " + JSON.stringify(payload));
    });

    this.broadcastService.subscribe("msal:loginSuccess", async (payload) => {
      this.token = payload["_token"];
      this.getMeProfile(payload["_token"]);
    });
    this.broadcastService.subscribe("msal:acquireTokenSuccess", (payload) => {
      console.log("acquireToken success " + JSON.stringify(payload));
    });

    this.subscription = this.broadcastService.subscribe(
      "msal:acquireTokenFailure",
      (payload) => {
        console.log("acquire token failure " + JSON.stringify(payload));
        if (
          payload.errorDesc.indexOf("consent_required") !== -1 ||
          payload.errorDesc.indexOf("interaction_required") != -1
        ) {
          this.authService.acquireTokenPopup(["user.read"]).then(
            (token) => {
              //this.getUSerProfile();
              //this.getMeProfile();
            },
            (error) => {}
          );
        }
      }
    );
  }
  getUSerProfile(tokenData, empData) {
    this.httpService.httpGetRequest(this.managerUrl).subscribe(
      (data) => {
        const {
          displayName,
          givenName,
          id,
          businessPhones,
          jobTitle,
          mail,
          mobilePhone,
          officeLocation,
          preferredLanguage,
          surname,
          userPrincipalName,
        } = data;
        this.managerData = {
          manager_displayName: displayName,
          manager_givenName: givenName,
          manager_id: id,
          manager_businessPhones: businessPhones,
          manager_jobTitle: jobTitle,
          manager_mail: userPrincipalName,
          manager_mobilePhone: mobilePhone,
          manager_surname: surname,
          manager_userPrincipalName: userPrincipalName,
          employee_ID: empData.employeeId ? empData.employeeId : "",
          displayName: empData.displayName ? empData.displayName : "",
        };
        this.spinnerService.hide();
        this.token = tokenData;
        this.userLogin(this.managerData);
      },
      (error) => {
        this.userLogin({});
        console.error(
          " Http get request to MS Graph failed" + JSON.stringify(error)
        );
      }
    );
  }

  userLogin(managerData) {
    this.loginApiSubscription = this.landingService
      .login(managerData)
      .subscribe(
        (res) => {
          if (res) {
            if (
              !res.payload.empData.unit &&
              !res.payload.empData.vertical &&
              !res.payload.empData.department &&
              res.payload.empData.Role != "ADMIN"
            ) {
              this.openDialog(res);
            } else {
              this.spinnerService.show();
              // 1:Super Admin, 2:Executive admin , 3:  Client admin 4: User
              this.loggedInUser = res.payload.empData;
              this.userObj = new UserDetails(res.payload.empData);
              this.checkRole(res.payload.empData);
              let bu =
                this.loggedInUser.businessUnit == "cdmo" ||
                this.loggedInUser.businessUnit == "discovery"
                  ? "aps"
                  : this.loggedInUser.businessUnit;
              this.configService.setConfig(bu);
            }
          }
        },
        (error) => {
          // this.spinnerService.hide();
          if (error.status === 404) {
            this.snackBar.open("Invalid Credentials", "OK", {
              duration: 3000,
            });
            this.router.navigate(["login"]);
          }
        }
      );
  }
  getMeProfile(token: any) {
    this.httpService.httpGetRequest(this.meUrl).subscribe(
      (data) => {
        //this.meData = data;
        if (data) {
          this.getUSerProfile(token, data);
        }
      },
      (error) => {
        console.error(
          " Http get request to MS Graph failed" + JSON.stringify(error)
        );
      }
    );
  }

  openDialog(empInfo: any): void {
    const emp = empInfo.payload.empData;
    const dialogRef = this.vertInfoDialog.open(
      VerticalDepartmentPopUpComponent,
      {
        width: "25%",
        data: { name: emp.Empname },
        disableClose: true,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.spinnerService.show();
      if (result) {
        let data = {
          Empno: emp.Empno,
          updateItems: result,
        };
        this.profileServ.updateDepartInfo(data).subscribe(
          (res) => {
            if (res) {
              this.loggedInUser = res.payload;
              this.userObj = new UserDetails(res.payload);
              this.checkRole(res.payload);
              let bu =
                this.loggedInUser.businessUnit == "cdmo" ||
                this.loggedInUser.businessUnit == "discovery"
                  ? "aps"
                  : this.loggedInUser.businessUnit;
              this.configService.setConfig(bu);
            }
          },
          (error) => {
            // this.spinnerService.hide();
            if (error.status === 404) {
              this.snackBar.open("Invalid Credentials", "OK", {
                duration: 3000,
              });
            }
          }
        );

        // this.managerData.unit = result.unit;
        // this.managerData.vertical = result.vertical;
        // this.managerData.department = result.department;
        // if (this.loginApiSubscription) {
        //   this.loginApiSubscription.unsubscribe();
        // }
        // this.userLogin(this.managerData);
      }
    });
  }

  /**
   * @function checkRole
   * @argument data The logged user detail to check the role
   * @returns null
   * @description
   * The function to restrict the end user with role "Admin" from
   * logging with small devices below 1024 resolutions.
   * The end user gets navigated if the user is not Admin
   * If the role is Admin the user further checks for device resolution
   * @author gaurav.rao
   */
  checkRole(data) {
    // console.log(data);
    this.spinnerService.hide();
    if (data.Role == "ADMIN" && window.screen.availWidth < 1024) {
      this.snackBar.open("Admin Login restricted for this device", "OK", {
        duration: 3000,
      });
    } else {
      this.router.navigate([this._initialRoutes[data.Role]]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/landing/landing.component.ts